<script>
    import { img_cdn } from './utils/image';

    export let puzzle;
    let className = '';
    export { className as class };

</script>

<a
    class="block aspect-1080/1350 puzzle hover:scale-105 transition-transform duration-300 ease-in-out {className}"
    href="/puzzles/{puzzle.slug}"
    style:--puzzle-card-slug="puzzle-card-{puzzle.slug}"
    style:--card-bg="{puzzle.color}"
>
    <img
        src={img_cdn(puzzle.images[0], { w: 480, h: 600 })}
        alt="{puzzle.head_description}"
        class="question w-full aspect-1080/1350 block rounded-lg bg-(--card-bg)"
    />
</a>



<style>
    .puzzle {
        view-transition-name: var(--puzzle-card-slug);
    }
</style>
